import axios, { AxiosResponse } from 'axios';

import { CustomerAddresses } from '../utils/models/account';
import { PaginatedResponse, PaginationMeta, PropertyFilter } from '../utils/models/paginated-response';
import {
    ClothingProductVariant,
    ExternalCodesVariant,
    ProductAvailability,
    ProductFilters,
    ProductVariant,
    QuantityObject,
} from '../utils/models/product';

export const getProductChildren = (
    sku: string,
    propertiesToFilter: PropertyFilter[],
    meta: PaginationMeta,
    accountCode?: string | null,
): Promise<AxiosResponse<PaginatedResponse<ProductVariant | ClothingProductVariant, ProductFilters>>> => {
    const foundSku = propertiesToFilter.find((property) => property.code == 'sku');

    const propertiesFiltered = propertiesToFilter.filter((property) => property.code !== 'sku');

    let params: any = {
        per_page: meta.per_page,
        page: meta.page,
        filters: {
            properties: propertiesFiltered,
        },
    };

    if (foundSku) {
        params.filters.sku = foundSku.value;
    }

    return axios.post(
        `/apps/berardi/products/${sku}/children${accountCode ? `?customerAccount=${accountCode}` : ''}`,
        params,
    );
};

export const getProductAvailability = (
    sku: string,
    accountCode?: string,
): Promise<AxiosResponse<ProductAvailability>> => {
    return axios.get(
        `/apps/berardi/products/children/${sku}/availability${accountCode ? `?customerAccount=${accountCode}` : ''}`,
    );
};

export const getVariantExternalCodes = (
    variantSku: string,
    accountCode: string,
): Promise<AxiosResponse<ExternalCodesVariant>> => {
    return axios.get(`/apps/berardi/products/children/${variantSku}/external-codes?customerAccount=${accountCode}`);
};

export const addVariantExternalCode = (
    variantSku: string,
    accountCode: string,
    externalCode: string,
): Promise<AxiosResponse<ExternalCodesVariant>> => {
    const params = {
        customerAccount: accountCode,
        code: externalCode,
        description: null,
    };

    return axios.post(`/apps/berardi/products/children/${variantSku}/external-codes`, params);
};
